import React, {useEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {LayoutSplashScreen} from '../../../../../_metronic/layout';
import {logout} from '../../_redux/authActions';
import {hideGlobalMessage} from '../../../_common/components/GlobalMessage/actions/hideGlobalMessage';

const Logout = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector(state => state.auth?.accessToken, shallowEqual);

  useEffect(() => {
    dispatch(hideGlobalMessage());
    dispatch(logout());
  }, []);

  return accessToken ? <LayoutSplashScreen/> : <Redirect to="/auth/login"/>;
};

export default Logout;
